import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'idnow-camera-embed',
  templateUrl: './camera-embed.component.html',
  styleUrls: ['./camera-embed.component.css']
})
export class CameraEmbedComponent implements OnInit {
  // File Model (Imagen)
  @Input() model: any;
  // Image Title
  @Input() title: string;
  // Background to show before the picture is taken
  @Input() defaultBackground: string;
  @Input() overlay: string;
  @Input() horizontalOnly: boolean;

  showOverlay: boolean;
  devices: any[] = [];
  deviceIndex = 0;
  enabled = false;

  h: number = screen.height;
  w: number = screen.width;

  // Picture url to use as picture preview
  url: string | ArrayBuffer;

  localUrl: any;

  fileCompresed : File;
  isOpen = false;
  image: any;
  divId: string = '';
  currentStream: any;

  // Ouput function to execute after the picture is taken
  @Output() takePicture = new EventEmitter<any>();

  constructor(private notifyService : NotificationService) {
    const random = Math.random();
    this.divId = 'cameraPreview_' + (random * Math.pow(10, (random+'').length));
    this.showOverlay = false;

    this.getDevices();
  }
  ngOnInit(): void {  }

  openCamera() {
    try {
      if (this.enabled) {
        let video = this.getVideoTag();
        let _this = this;
    
        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({ video: true }).then(function(stream) {
            _this.isOpen = true;
            video.srcObject = stream;
            
            _this.showOverlay = _this.overlay ? true : false;
            video.play();
          }, error => {
            console.log('error getting camera stream: ', error);
            this.notifyService.showError(error, "No se puede abrir la cámara del dispositivo");
          });
        }
      }
    } catch (error) {
        console.log('error opening camera stream: ', error);
        this.notifyService.showError("", "No se puede abrir la cámara del dispositivo");
    }
  }
  closeCamera() {
    this.showOverlay = false;
    this.isOpen = false;

    let video = this.getVideoTag();
    this.stopMediaTracks(video);
  }

  captureImage() {
    const canvas = this.getCanvasTag();
    const video = this.getVideoTag();
    const ctx = canvas.getContext('2d');

    this.model = this.validatePicture(video, ctx, canvas);
    
    this.url = this.model;
    
    const result = {height: this.h, width: this.w, url: this.model};
    this.closeCamera();

    this.takePicture.emit(result);
  }

  switchCamera() {
    let video = this.getVideoTag();
    this.stopMediaTracks(video);

    if (this.deviceIndex === this.devices.length - 1) {
      this.deviceIndex = 0;
    } else {
      this.deviceIndex++;
    }

    const _dev = this.devices[this.deviceIndex];

    const constraints = {
      audio: false,
      video: {
        deviceId: {exact: _dev.deviceId}
      }
    };

    navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        this.currentStream = stream;
        video.srcObject = stream;
        video.play();
      }, error => {
        console.log('error switching camera devices: ', error);
        this.notifyService.showError(error, "No se puedo cambiar la cámara del dispositivo");
      })
      .catch(error => {
        console.error(error);
      });
  }

  private getCanvasTag(): any {
    const id = '.canvas_'+this.divId;
    return document.querySelector(id);
  }
  private getVideoTag(): any {
    const id = '.video_'+this.divId;
    return document.querySelector(id);
  }

  private stopMediaTracks(videoElement) {
    videoElement.srcObject.getTracks().forEach(track => {
      track.stop();
    });
  }

  private getDevices() {
    try {
      navigator.mediaDevices.enumerateDevices().then(
        success => {
          if (success) {
            success.forEach(device => {
              if (device.kind === 'videoinput') {
                this.devices.push(device);
              }
            })

            this.checkEnable();
          }
        }, error => {
          console.log('error getting camera devices: ', error);
          this.notifyService.showError(error, "No se puedo obtener acceso a las cámaras del dispositivo");
      });
    } catch (error) {
      console.log('error getting camera devices: ', error);
      this.notifyService.showError(error, "No se puedo obtener acceso a las cámaras del dispositivo");
    }
  }

  private checkEnable() {
    if (this.devices && this.devices.length > 0) {
      this.enabled = true;
    } else {
      this.notifyService.showError("No se encontraron cámaras en el dispositivo", "Error");
    }
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    this.h = screen.height;
    this.w = screen.width;
  }
  
  validatePicture(video: any, ctx: any, canvas: any): any {
    if (this.horizontalOnly && this.h > this.w) {
      canvas.width = this.h;
      canvas.height = this.w;

      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(-90 * Math.PI / 180);

      // ctx.drawImage(video, 0, 0, this.h, this.w);
      ctx.drawImage(video, this.w / -2, this.h / -2);
      return canvas.toDataURL("image/png");
    } else {
      canvas.width = this.w;
      canvas.height = this.h;
      ctx.drawImage(video, 0, 0, this.w, this.h);
      return canvas.toDataURL("image/png");
    }
  }

  turnImage(picture: any, degrees: number): any {
    return picture;
  }
}
